module.exports = __webpack_public_path__ + "img/text2.7c78500c.png";